/**
 * SHEIN 列表导出辅助：分页拉取 + 按时间字段筛选。
 */

export const EXPORT_TIME_TYPE_OPTIONS = [
  { value: 'created', label: '创建时间' },
  { value: 'published', label: '发布时间' },
  { value: 'listed', label: '上架时间' },
];

export function parseExportDateTime(value) {
  if (value == null || value === '') return NaN;
  const text = String(value).trim();
  if (!text || text === '—' || text === '自动上架') return NaN;
  const normalized = text.includes('T') ? text : text.replace(' ', 'T');
  const ts = Date.parse(normalized);
  return Number.isFinite(ts) ? ts : NaN;
}

export function isTimeInRange(value, startTime, endTime) {
  const ts = parseExportDateTime(value);
  const start = parseExportDateTime(startTime);
  const end = parseExportDateTime(endTime);
  if (!Number.isFinite(ts) || !Number.isFinite(start) || !Number.isFinite(end)) {
    return false;
  }
  return ts >= start && ts <= end;
}

export function pickProductExportTime(row, timeType) {
  if (!row) return '';
  if (timeType === 'published') return row.publishedAt || '';
  if (timeType === 'listed') return row.listedAt || '';
  return row.createdAt || '';
}

export function pickPublishRecordExportTime(row, timeType) {
  if (!row) return '';
  if (timeType === 'published') return row.publishedAt || row.finishedAt || '';
  if (timeType === 'listed') {
    return row.listedAt || row.hopeOnSaleDate || row.shelfLabel || '';
  }
  return row.createdAt || '';
}

/**
 * 按页拉取列表直至取完。
 * @param {(page:number,pageSize:number)=>Promise<{items?:any[],total?:number}>} fetchPage
 */
export async function fetchAllPages(fetchPage, { pageSize = 100, maxPages = 500 } = {}) {
  const all = [];
  let page = 1;
  let expectedTotal = Infinity;
  while (page <= maxPages && all.length < expectedTotal) {
    // eslint-disable-next-line no-await-in-loop
    const res = await fetchPage(page, pageSize);
    const list = Array.isArray(res?.items) ? res.items : [];
    const total = Number(res?.total);
    if (Number.isFinite(total) && total >= 0) {
      expectedTotal = total;
    }
    all.push(...list);
    if (!list.length || list.length < pageSize) break;
    page += 1;
  }
  return all;
}
